import type { LucideIcon } from "lucide-react";
import { Flag } from "lucide-react";
import { SCREEN_META, type ScreenKey, type Params } from "@/core/screen-meta";

export interface MenuEntry {
  label: string;
  icon: LucideIcon;
  screen?: ScreenKey;
  params?: Params;
  action?: "encerrar-viagem";
  shortcut?: string;
  separatorBefore?: boolean;
}

export interface MenuDef {
  id: string;
  label: string;
  items: MenuEntry[];
}

const s = (screen: ScreenKey, extra: Partial<MenuEntry> = {}): MenuEntry => {
  const t = SCREEN_META[screen].title;
  return { label: typeof t === "string" ? t : screen, icon: SCREEN_META[screen].icon, screen, ...extra };
};

export const MENUS: MenuDef[] = [
  {
    id: "operacao",
    label: "Operação",
    items: [
      s("nova-viagem", { label: "Nova viagem", shortcut: "F2" }),
      s("viagens"),
      { ...s("mdfes"), label: "MDF-e em aberto", params: { situacao: "aberto" } },
      { label: "Encerrar viagem", icon: Flag, action: "encerrar-viagem", separatorBefore: true },
      // Monitoramento: quem precisa é a operação, na hora de emitir
      s("sefaz-status", { separatorBefore: true }),
    ],
  },
  {
    id: "documentos",
    label: "Documentos",
    items: [s("ctes"), s("mdfes"), s("ciots"), s("averbacoes"), s("eventos", { separatorBefore: true })],
  },
  {
    id: "financeiro",
    label: "Financeiro",
    items: [s("contas-receber"), s("contas-pagar"), s("pagamentos-tac", { separatorBefore: true }), s("quitacoes"), s("relatorios", { separatorBefore: true }), s("exportacoes")],
  },
  {
    id: "cadastros",
    label: "Cadastros",
    items: [s("tomadores"), s("veiculos"), s("motoristas"), s("tabelas-frete", { separatorBefore: true }), s("regioes-frete"), s("componentes-frete"), s("apolices", { separatorBefore: true })],
  },
  {
    // id mantido ("sistema") por causa dos ícones e das permissões; só o rótulo muda
    id: "sistema",
    label: "Configurações",
    items: [
      // Conta
      s("empresa"),
      s("usuarios"),
      // Plano e cobrança da conta; só existe com a API real
      s("assinatura"),
      // Fiscal
      s("certificado", { separatorBefore: true }),
      s("ambiente"),
      s("series"),
      s("regras-icms"),
      // Ferramentas (Preferências foi para o menu do usuário)
      s("integracoes", { separatorBefore: true }),
    ],
  },
];

export const SHORTCUTS: { keys: string; label: string }[] = [
  { keys: "F2", label: "Nova viagem" },
  { keys: "F3 · Ctrl+K", label: "Buscar" },
  { keys: "F5", label: "Atualizar" },
  { keys: "F10", label: "Salvar" },
  { keys: "Esc", label: "Fechar / cancelar" },
  { keys: "Ctrl+W · Alt+W", label: "Fechar aba" },
  { keys: "Ctrl+Tab · Alt+→", label: "Próxima aba" },
  { keys: "Ctrl+Shift+Tab · Alt+←", label: "Aba anterior" },
  { keys: "Delete", label: "Excluir selecionado" },
  { keys: "Alt", label: "Focar menu" },
  { keys: "↑ ↓ · Enter", label: "Navegar e abrir na grade" },
  { keys: "?", label: "Mapa de atalhos" },
];
